import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import { LoginPage } from "./pages/LoginPage";
import { HomePage } from "./pages/HomePage";
import { ParcoursPage } from "./pages/ParcoursPage";
import { QuizPage } from "./pages/QuizPage";
import { SatisfactionPage } from "./pages/SatisfactionPage";
import { SuggestionsPage } from "./pages/SuggestionsPage";
import { AdminPage } from "./pages/AdminPage";
import ManacademyHomePage from "./pages/ManacademyHomePage";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#f2f2f2] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#571925]"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/vipplus/login" replace />;
  }
  
  return children;
};

// Public Route - redirects to home if already logged in
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#f2f2f2] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#571925]"></div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/vipplus" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Page d'accueil Manacademy - publique */}
      <Route path="/" element={<ManacademyHomePage />} />
      
      {/* Redirection de compatibilité */}
      <Route path="/login" element={<Navigate to="/vipplus/login" replace />} />
      
      {/* Routes VIPPLUS */}
      <Route 
        path="/vipplus/login" 
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } 
      />
      
      <Route 
        path="/vipplus" 
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/parcours" 
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/parcours/:id" 
        element={
          <ProtectedRoute>
            <ParcoursPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/parcours/:id/quiz" 
        element={
          <ProtectedRoute>
            <QuizPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/feedback/satisfaction" 
        element={
          <ProtectedRoute>
            <SatisfactionPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/feedback/suggestions" 
        element={
          <ProtectedRoute>
            <SuggestionsPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/vipplus/admin" 
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      
      {/* Catch all - redirect vers l'accueil */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#ffffff',
                color: '#000000',
                border: '1px solid #e5e7eb',
              },
              className: 'toast-custom',
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
